<template>
  <BlogArchive kind="tag" />
</template>

<script>
import BlogArchive from './BlogArchive'

export default {
  name: 'BlogTagPosts',
  components: { BlogArchive }
}
</script>
